var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c;
import { Vue, Component, Watch, Ref } from "vue-facing-decorator";
import { State } from "vuex-facing-decorator";
import { LicenseState } from "@/app/store/modules/license.state";
import { LoginState } from "@/app/store/modules/login.state";
import { AppConfigState } from "@/app/store/modules/appconfig.state";
import { CompaniesClient, CompanyModel, CompanyTypesClient, CountriesClient, CurrenciesClient, RegionsClient, AddressModel, CreateCompanyCommand, UpdateCompanyCommand, AccountStatusEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { Alert } from "@/common/utils/alert";
import ArtificialNotificationAddressesVue from "@/app/vues/company/artificial-notification-addresses.vue";
import CompanySystemOverviewVue from "@/app/vues/admin/company-system-overview.vue";
import CompanySystemCategoriesVue from "@/app/vues/admin/company-system-categories.vue";
import CompanyContactsVue from "@/app/vues/admin/company-contacts.vue";
import CompanySystemsVue from "@/app/vues/admin/company-systems.vue";
import CompanyUsersVue from "@/app/vues/admin/company-users.vue";
import CompanySitesVue from "@/app/vues/admin/company-sites.vue";
import CompanySettingsVue from "@/app/vues/admin/company-settings.vue";
import CompanySsoConfigurationVue from "@/app/vues/admin/company-sso-configuration.vue";
import DataCollectorRegisterVue from "@/app/vues/admin/company-data-collector-register.vue";
import CompanyEditionVue from "@/app/vues/admin/company-edition.vue";
import { HttpHelper } from "@/app/utils/http-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { DateHelper } from "@/app/utils/date-helper";
import RouteNames from "@/app/router/routes";
import "@/app/component-hooks";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const companyTypeClient = new CompanyTypesClient(window.apiUrl);
const companiesClient = new CompaniesClient(window.apiUrl);
const countryClient = new CountriesClient(window.apiUrl);
const currencyClient = new CurrenciesClient(window.apiUrl);
const regionClient = new RegionsClient(window.apiUrl);
let CompanyVue = class CompanyVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.companyId = 0;
        this.loaded = false;
        this.working = false;
        this.goingBack = false;
        this.attemptedSave = false;
        this.activeTab = 0;
        this.tabs = ["#systems", "#systemcategories", "#sites", "#users", "#contacts", "#notifications", "#settings", "#details", "#logo", "#twoFactorAuth", "#sso", "#dataCollectorRegister", "#edition"];
        this.enable2FA = false;
        this.twoFactorAuthAppAuth = false;
        this.twoFactorAuthEmail = false;
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig(false);
        // components
        this.msg = new Alert();
        // models
        this.company = new CompanyModel();
        // arrays
        this.companyTypes = [];
        this.countries = [];
        this.currencies = [];
        this.regions = [];
        this.awsRegions = [
            { value: "us-east-1", text: "US East (N. Virginia)" },
            { value: "us-east-2", text: "US East (Ohio)" },
            { value: "us-west-1", text: "US West (N. California)" },
            { value: "us-west-2", text: "US West (Oregon)" },
            { value: "ca-central-1", text: "Canada (Central)" },
            { value: "eu-west-1", text: "Europe (Ireland)" },
            { value: "eu-west-2", text: "Europe (London)" },
            { value: "eu-west-3", text: "Europe (Paris)" },
            { value: "eu-central-1", text: "Europe (Frankfurt)" },
            { value: "eu-north-1", text: "Europe (Stockholm)" },
            { value: "ap-south-1", text: "Asia Pacific (Mumbai)" },
            { value: "ap-southeast-1", text: "Asia Pacific (Singapore)" },
            { value: "ap-southeast-2", text: "Asia Pacific (Sydney)" },
            { value: "ap-northeast-1", text: "Asia Pacific (Tokyo)" },
            { value: "ap-northeast-2", text: "Asia Pacific (Seoul)" },
            { value: "sa-east-1", text: "South America (São Paulo)" }
        ];
        this.accountStatusOptions = [
            { value: AccountStatusEnum.Active, text: "Active" },
            { value: AccountStatusEnum.Overdue, text: "Overdue" },
            { value: AccountStatusEnum.Suspended, text: "Suspended" }
        ];
    }
    created() {
        this.activeTab = this.tabs.findIndex(tab => tab === this.$route.hash);
        this.companyId = parseInt(this.$route.params.id) || 0;
        this.get();
        this.getLookups();
    }
    ;
    mounted() {
    }
    ;
    // we have to monitor route changes in order to make Vue react to the change
    beforeRouteUpdate(to, from, next) {
        // prevent going back between different tabs in company page.
        if ((to === null || to === void 0 ? void 0 : to.path) == (from === null || from === void 0 ? void 0 : from.path) && this.goingBack) {
            this.goingBack = false;
            this.$router.push({ name: RouteNames.Companies });
        }
        this.companyId = parseInt(to.params.id || 0);
        this.company = new CompanyModel();
        this.get();
        next();
    }
    ;
    // get
    get() {
        if (this.isNewCompany) {
            let company = new CompanyModel();
            company.init({});
            this.map(company);
            this.loaded = true;
            return;
        }
        this.working = true;
        // fetch company record
        companiesClient
            .get(this.companyId)
            .then(response => {
            var _a, _b;
            if (!response) {
                this.$router.push({ name: RouteNames.Home });
                return;
            }
            this.loaded = true;
            this.map(response);
            // Set SSO configuration if available
            if (this.ssoConfig && response.ssoConfiguration) {
                this.ssoConfig.setSsoConfiguration(response.ssoConfiguration);
            }
            this.setValues({
                name: this.company.companyName,
                email: ((_a = this.company.primaryAddress) === null || _a === void 0 ? void 0 : _a.emailAddress) || undefined,
                phone: ((_b = this.company.primaryAddress) === null || _b === void 0 ? void 0 : _b.phone) || undefined,
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getLookups() {
        let promises = [
            companyTypeClient
                .getList()
                .then((response) => {
                let defaultCompanyType = { value: null, text: TextHelper.emptyListItemName };
                this.companyTypes = [defaultCompanyType].concat((response || []).map((item) => {
                    let option = { value: item.companyTypeId, text: item.companyTypeName || "" };
                    return option;
                }));
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            countryClient
                .getList()
                .then((response) => {
                let defaultCountry = { value: null, text: TextHelper.emptyListItemName };
                this.countries = [defaultCountry].concat((response || []).map((item) => {
                    let option = { value: item.countryId, text: item.countryName || "" };
                    return option;
                }));
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            currencyClient
                .getList()
                .then((response) => {
                let defaultCurrency = { value: null, text: TextHelper.emptyListItemName };
                this.currencies = [defaultCurrency].concat((response || []).map((item) => {
                    let option = { value: item.currencyId, text: `${item.currencyCode} - ${item.currencyName}` };
                    return option;
                }));
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }),
            regionClient
                .getList()
                .then((response) => {
                let defaultRegion = { value: null, text: TextHelper.emptyListItemName };
                this.regions = [defaultRegion].concat((response || []).map((item) => {
                    let option = { value: item.regionId, text: item.regionName || "", parentKey: item.countryId };
                    return option;
                }));
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
        ];
        Promise.all(promises);
    }
    ;
    map(company) {
        var _a, _b, _c;
        this.company = company;
        this.company.companyTypeId = company.companyTypeId || null;
        // set up primary address for this company.
        if (this.company.primaryAddress == null) {
            let address = new AddressModel();
            address.authorId = this.company.authorId;
            address.companyId = this.company.companyId;
            address.countryId = null;
            address.regionId = null;
            this.company.primaryAddress = address;
        }
        this.enable2FA = ((_a = company.twoFactorAuthMethods) === null || _a === void 0 ? void 0 : _a.length) > 0;
        if (this.enable2FA) {
            this.twoFactorAuthAppAuth = (_b = company.twoFactorAuthMethods) === null || _b === void 0 ? void 0 : _b.includes(2);
            this.twoFactorAuthEmail = (_c = company.twoFactorAuthMethods) === null || _c === void 0 ? void 0 : _c.includes(1);
        }
    }
    ;
    // set
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.working)
                return;
            if (this.notifications && !this.notifications.validateNotifications()) {
                Notifier.onError("Please check for errors on Notifications.");
                return;
            }
            if (this.settings && !(yield this.settings.validateSettings())) {
                Notifier.onError("Please check for errors on Settings.");
                return;
            }
            if (this.ssoConfig && !this.ssoConfig.validate()) {
                Notifier.onError("Please check for errors on SSO Configuration.");
                this.activeTab = this.tabs.indexOf("#sso");
                return;
            }
            if (this.enable2FA && !(this.twoFactorAuthAppAuth || this.twoFactorAuthEmail)) {
                Notifier.onError("Please select at least one Two Factor Authentication Method.");
                return;
            }
            let accountDueDate = this.company.accountDueDate ? DateHelper.convertToDate(this.company.accountDueDate.toString()) : null;
            if (this.company.accountStatus == AccountStatusEnum.Overdue && !accountDueDate) {
                Notifier.onError("Please enter the Account Due Date.");
                return;
            }
            if (this.company.accountStatus == AccountStatusEnum.Overdue && accountDueDate >= Date.now()) {
                Notifier.onError("Please enter a Date in the past for Account Due Date.");
                return;
            }
            const handleSubmitAction = this.handleSubmit(() => {
                let notificationsList = [];
                if (!this.isNewCompany && this.notifications) {
                    notificationsList = this.notifications.getNotifications();
                    this.company.maxDailyAlarmEmailLimitPerSystem = this.notifications.maxDailyAlarmEmailLimitPerSystem;
                    this.company.maxDailyAlarmSmsLimitPerSystem = this.notifications.maxDailyAlarmSmsLimitPerSystem;
                }
                if (this.enable2FA) {
                    this.company.twoFactorAuthMethods = [];
                    if (this.twoFactorAuthAppAuth)
                        this.company.twoFactorAuthMethods.push(2);
                    if (this.twoFactorAuthEmail)
                        this.company.twoFactorAuthMethods.push(1);
                }
                else {
                    this.company.twoFactorAuthMethods = [];
                }
                this.company.accountDueDate = this.company.accountDueDate ? DateHelper.convertToDate(this.company.accountDueDate.toString()) : null;
                let predictionSettings = this.settings ? this.settings.getBatteryLifePredictionSettings() : null;
                let issueSettings = this.settings ? this.settings.getIssueSettings() : null;
                let companyServicesSettings = this.settings ? this.settings.getCompanyServicesSettings() : null;
                // Include SSO configuration in company model
                if (this.ssoConfig && !this.isNewCompany) {
                    let ssoConfiguration = this.ssoConfig ? this.ssoConfig.getSsoConfiguration() : null;
                    if (ssoConfiguration)
                        this.company.ssoConfiguration = ssoConfiguration;
                }
                let promise = () => {
                    var _a;
                    return this.isNewCompany
                        ? companiesClient.add(new CreateCompanyCommand({ requestModel: this.company }))
                        : companiesClient.update((_a = this.company.companyId) !== null && _a !== void 0 ? _a : 0, new UpdateCompanyCommand({
                            requestModel: this.company,
                            notifications: notificationsList,
                            batteryLifePredictionSettings: predictionSettings,
                            issueSettings: issueSettings,
                            companyServicesSettings: companyServicesSettings
                        }));
                };
                promise()
                    .then(response => {
                    var _a;
                    if (this.isNewCompany) {
                        this.$router.push({ name: RouteNames.Company, params: { id: response.toString() } });
                        return;
                    }
                    this.companyId = response;
                    if ((_a = this.notifications) === null || _a === void 0 ? void 0 : _a.reload) {
                        this.notifications.reload();
                    }
                    Notifier.onOk();
                    this.get();
                })
                    .catch(ex => {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                })
                    .finally(() => {
                    this.working = false;
                });
            }, () => {
                Notifier.onError("Please check that you have correctly entered all details.");
            });
            handleSubmitAction();
        });
    }
    ;
    archive() {
        if (this.working)
            return;
        companiesClient
            .getArchiveImpact(this.company.companyId)
            .then((impact) => {
            const parts = [];
            if (impact.sitesCount > 0) {
                parts.push(`${impact.sitesCount} site${impact.sitesCount === 1 ? '' : 's'}`);
            }
            if (impact.systemsCount > 0) {
                parts.push(`${impact.systemsCount} system${impact.systemsCount === 1 ? '' : 's'}`);
            }
            if (impact.usersCount > 0) {
                parts.push(`${impact.usersCount} user${impact.usersCount === 1 ? '' : 's'}`);
            }
            let msg;
            if (parts.length > 0) {
                let subjects = '';
                if (parts.length === 1) {
                    subjects = parts[0];
                }
                else if (parts.length === 2) {
                    subjects = `${parts[0]} and ${parts[1]}`;
                }
                else {
                    subjects = `${parts.slice(0, -1).join(', ')}, and ${parts[parts.length - 1]}`;
                }
                msg = `Archiving this company will also archive ${subjects}. Are you sure you want to continue?`;
            }
            else {
                msg = "Are you sure that you want to archive this company?";
            }
            this.$confirmModal.show(msg)
                .then((value) => {
                if (!value)
                    return;
                this.performArchive();
            });
        });
    }
    performArchive() {
        this.working = true;
        companiesClient
            .delete(this.company.companyId)
            .then(() => {
            this.company.whenDeleted = new Date();
            Notifier.onOk(`Company # ${this.company.companyId} has been successfully archived.`);
            this.systems.reload();
            this.sites.reload();
            this.users.reload();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    restore() {
        if (this.working || this.isNewCompany)
            return;
        this.working = true;
        companiesClient
            .restore(this.company.companyId)
            .then(() => {
            this.company.whenDeleted = undefined;
            Notifier.onOk(`Company # ${this.company.companyId} has been successfully restored.`);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    goBack() {
        this.goingBack = true;
        this.$router.back();
    }
    ;
    validate() {
        this.msg.clear();
        let valid = this.isValid;
        if (!valid)
            this.msg.error("Please complete all required fields.");
        return valid;
    }
    ;
    onContactsUpdated() {
        var _a;
        if ((_a = this.notifications) === null || _a === void 0 ? void 0 : _a.reload) {
            this.notifications.reload();
        }
    }
    onSiteArchived() {
        var _a;
        console.log("Site archived - reloading systems tab");
        if ((_a = this.systems) === null || _a === void 0 ? void 0 : _a.reload) {
            this.systems.reload();
        }
    }
    // computed
    get pageTitle() {
        return this.isNewCompany ? "New Company" : this.companyTitle;
    }
    get companyTitle() {
        if (!this.company)
            return "";
        return TextHelper.getRecordTitle(this.company.companyName || "", this.isCompanyArchived);
    }
    ;
    get isNewCompany() {
        return !this.companyId;
    }
    ;
    get isCompanyArchived() {
        return this.company.whenDeleted != null;
    }
    ;
    get isCompanyNameInvalid() {
        return this.attemptedSave && !this.company.companyName;
    }
    ;
    get isValid() {
        return !this.isCompanyNameInvalid;
    }
    ;
    get companyType() {
        return this.companyTypes.filter(item => {
            return item.value == this.company.companyTypeId;
        })[0] || null;
    }
    ;
    set companyType(item) {
        if (!item)
            return;
        if (!this.company)
            return;
        this.company.companyTypeId = item.value;
    }
    ;
    get accountStatus() {
        return this.accountStatusOptions.filter(item => {
            return item.value == this.company.accountStatus;
        })[0] || this.accountStatusOptions[0];
    }
    ;
    set accountStatus(item) {
        if (!item)
            return;
        if (!this.company)
            return;
        this.company.accountStatus = item.value;
    }
    ;
    get country() {
        return this.countries.filter(item => {
            if (!this.company.primaryAddress)
                return null;
            return item.value == this.company.primaryAddress.countryId;
        })[0] || null;
    }
    ;
    set country(item) {
        if (!item)
            return;
        if (!this.company.primaryAddress)
            return;
        this.company.primaryAddress.countryId = item.value;
    }
    ;
    get region() {
        return this.regions.filter(item => {
            if (!this.company.primaryAddress)
                return null;
            return item.value == this.company.primaryAddress.regionId;
        })[0] || null;
    }
    ;
    set region(item) {
        if (!item)
            return;
        if (!this.company.primaryAddress)
            return;
        this.company.primaryAddress.regionId = item.value;
    }
    ;
    get currency() {
        return this.currencies.filter(item => {
            return item.value == this.company.currencyId;
        })[0] || null;
    }
    ;
    set currency(item) {
        if (!item)
            return;
        if (!this.company)
            return;
        this.company.currencyId = item.value;
    }
    ;
    get awsRegion() {
        return this.awsRegions.filter(item => {
            return item.value == this.company.awsRegion;
        })[0] || null;
    }
    ;
    set awsRegion(item) {
        if (!item)
            return;
        if (!this.company)
            return;
        this.company.awsRegion = item.value;
    }
    ;
    get selectPlaceholder() {
        return TextHelper.emptyListItemName;
    }
    ;
    get isClientAdministrator() {
        return this.loginState.isClientAdministratorUser;
    }
    ;
    get isAdministrator() {
        return this.loginState.isPowerShieldAdministrator;
    }
    ;
    get isCloudHosting() {
        return this.licenseState.isCloud;
    }
    ;
    get isSsoEnabledGlobally() {
        return this.appConfigState.ssoEnabled === true;
    }
    get isStandardOrHigher() {
        return this.licenseState.isStandardEdition || this.licenseState.isPremiumEdition;
    }
    ;
    // subscriptions
    setCountry() {
        if (!this.company.primaryAddress) {
            this.company.countryId = null;
            return;
        }
        this.company.countryId = this.company.primaryAddress.countryId || null;
    }
    ;
    rememberSelectedTab() {
        history.replaceState(history.state, "", this.tabs[this.activeTab]);
        this.$router.replace({ hash: this.tabs[this.activeTab] });
    }
    ;
    on2FAChanged() {
        if (!this.enable2FA) {
            this.twoFactorAuthAppAuth = false;
            this.twoFactorAuthEmail = false;
        }
    }
    chooseCompanyLogo() {
        if (!this.logoInput)
            return;
        console.log(this.logoInput);
        this.logoInput.click();
    }
    companyLogoChange() {
        if (!this.logoInput)
            return;
        const files = this.logoInput.files;
        if (files && files[0]) {
            const file = files[0];
            var pattern = /image-*/;
            if (!file.type.match(pattern)) {
                Notifier.onError("Invalid File Format!");
                return;
            }
            if (file.size > 1024 * 1024 * 2) {
                Notifier.onError("File size is too big. Please, select a file smaller than 2 mb!");
                return;
            }
            const reader = new FileReader;
            reader.onload = e => {
                this.company.companyLogo = e.target.result;
            };
            reader.readAsDataURL(file);
        }
    }
    clearCompanyLogo() {
        this.company.companyLogo = null;
    }
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], CompanyVue.prototype, "loginState", void 0);
__decorate([
    State("licenseModule"),
    __metadata("design:type", typeof (_b = typeof LicenseState !== "undefined" && LicenseState) === "function" ? _b : Object)
], CompanyVue.prototype, "licenseState", void 0);
__decorate([
    State("appConfigModule"),
    __metadata("design:type", typeof (_c = typeof AppConfigState !== "undefined" && AppConfigState) === "function" ? _c : Object)
], CompanyVue.prototype, "appConfigState", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], CompanyVue.prototype, "systems", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], CompanyVue.prototype, "sites", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], CompanyVue.prototype, "users", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], CompanyVue.prototype, "notifications", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], CompanyVue.prototype, "settings", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], CompanyVue.prototype, "ssoConfig", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], CompanyVue.prototype, "logoInput", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], CompanyVue.prototype, "edition", void 0);
__decorate([
    Watch("company.primaryAddress.countryId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyVue.prototype, "setCountry", null);
__decorate([
    Watch("activeTab"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyVue.prototype, "rememberSelectedTab", null);
__decorate([
    Watch("enable2FA"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanyVue.prototype, "on2FAChanged", null);
CompanyVue = __decorate([
    Component({
        name: "CompanyVue",
        components: {
            ArtificialNotificationAddressesVue,
            CompanySystemCategoriesVue,
            CompanyContactsVue,
            CompanySystemOverviewVue,
            CompanySystemsVue,
            CompanyUsersVue,
            CompanySitesVue,
            CompanySettingsVue,
            CompanySsoConfigurationVue,
            DataCollectorRegisterVue,
            CompanyEditionVue
        },
        setup() {
            const { errors, handleSubmit, defineInputBinds, setValues } = useForm({
                validationSchema: yup.object({
                    name: yup.string().trim().required(),
                    email: yup.string().email(),
                    phone: yup.string().phoneNumber(),
                }),
            });
            const nameVal = defineInputBinds('name');
            const emailVal = defineInputBinds('email');
            const phoneVal = defineInputBinds('phone');
            return {
                errors,
                handleSubmit,
                setValues,
                nameVal,
                emailVal,
                phoneVal,
            };
        }
    })
], CompanyVue);
export default CompanyVue;
